import { render, staticRenderFns } from "./RiskWarning.vue?vue&type=template&id=49f64018&scoped=true"
import script from "./RiskWarning.vue?vue&type=script&lang=js"
export * from "./RiskWarning.vue?vue&type=script&lang=js"
import style0 from "./RiskWarning.vue?vue&type=style&index=0&id=49f64018&prod&scoped=true&lang=scss"
import style1 from "./RiskWarning.vue?vue&type=style&index=1&id=49f64018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f64018",
  null
  
)

export default component.exports